import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import {  EmployeeAgreementTemplateBO } from './employee-agreement-template.model';

@Injectable({
  providedIn: 'root'
})
export class EmployeeAgreementTemplateService {

  constructor(private http: HttpClient, public errorService: ErrorService) { }

  saveEmployeeTemplate(templateBo:EmployeeAgreementTemplateBO): Observable<any> {
    let url = "api/EmployeeAgreement/SaveEmpDocTemplate";
    return this.http.post<any>(url,templateBo,{ observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getEmployeeTemplate(params:URLSearchParams): Observable<any> {
    let url = "api/EmployeeAgreement/GetEmployeeTemplate?";
    return this.http.get<any>(url+params,{ observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  
//==============================get employee permission==========================================//
 getpermission(paramsData: URLSearchParams): Observable<any> {
  let url = "api/FunctionPermission/getfunctionpermissionemployee?";
  return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
    map(data => data.body),
    catchError(this.errorService.handleError)
  )
}
}
